import React, { useState, useId, useRef, useEffect } from "react";
import {
  CalendarDaysIcon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import Button from "../button";
import Calendar from "react-calendar";
import moment from "moment";

const DashboardAdminCalendar = ({
  calendarFilter,
  compareFilter,
  selectedCalendarFilter,
  calendarFilterChange,
  selectedCompareFilter,
  compareFilterChange,
  handleCalendarChange,
  selectRange,
  setSelectRange,
  handleDateFilter,
  calendarOpen,
  setCalendarOpen,
  handleOpen,
  handleClose,
}) => {
  const calendarFilterID = useId();
  const compareFilterID = useId();
  const calendarRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleOutsideClick = (event) => {
    if (calendarRef.current && !calendarRef.current.contains(event.target)) {
      setCalendarOpen(false);
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div
      className="max-w-[625px] md:min-w-[625px] w-full relative"
      ref={calendarRef}
    >
      <div
        className="bg-white border border-[#EBEFF3] rounded-[10px] py-3 pl-2 pr-2 md:pr-11 md:h-12 flex md:items-center gap-2.5 md:gap-0 cursor-pointer relative w-full"
        onClick={handleOpen}
      >
        <div className="md:mr-3">
          <CalendarDaysIcon className="w-6 h-6" />
        </div>
        <form className="flex md:items-center flex-col md:flex-row gap-1 md:gap-0 mr-3 md:mr-0">
          <label className="block text-xs md:text-sm font-medium leading-[160%] text-[#485868] md:px-3 md:border-l md:border-[#EBEFF3] cursor-pointer">
            <b className="text-customGray">{selectedCalendarFilter}:</b>{" "}
            {selectRange?.startDate} - {selectRange?.endDate}
          </label>
          <label className="block text-xs md:text-sm font-medium leading-[160%] text-[#485868] md:px-3 md:border-l md:border-[#EBEFF3] cursor-pointer">
            <b className="text-customGray">Compared to:</b>{" "}
            {selectedCompareFilter}
          </label>
        </form>
        <div className="pl-3 md:border-l md:border-[#EBEFF3] h-[22px] flex items-center justify-end absolute right-2 top-3">
          {calendarOpen ? (
            <XMarkIcon className="w-[14px] h-[14px] text-[#EF2121]" />
          ) : (
            <ChevronDownIcon className="w-[14px] h-[14px] text-customGray" />
          )}
        </div>
      </div>
      <div
        className={`dataCalendar bg-white border border-[#EBEFF3] rounded-md px-3 py-4 md:p-[30px] pt-5 absolute w-full right-0 top-[4.5rem] md:top-12 flex justify-between flex-col md:flex-row z-[400] shadow-md ${
          calendarOpen ? "dataCalendarOpen" : ""
        }`}
      >
         {/* desktop view  */}
        <div className="hidden md:block">
          <div>
            <h6 className="text-base font-bold leading-[160%] text-[#04091E] mb-4">
              Calendar
            </h6>
            <div>
              {calendarFilter.map((item, index) => (
                <div className="max-w-[152px] w-full form-group3" key={index}>
                  <ul className="flex items-center w-full gap-[20px]">
                    <li className="flex items-center gap-[12px] mb-3">
                      <input
                        type="radio"
                        id={calendarFilterID + index}
                        name={"calendar-selector" + calendarFilterID + index}
                        checked={item.text == selectedCalendarFilter}
                        onChange={() => calendarFilterChange(item.text)}
                      />
                      <label
                        htmlFor={calendarFilterID + index}
                        className="text-base font-normal leading-[160%] text-customGray"
                      >
                        {item.text}
                      </label>
                      <div className="check"></div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
            <h6 className="text-base font-bold leading-[160%] text-[#04091E] mb-4">
              Compared to
            </h6>
            <div>
              {compareFilter.map((item, index) => (
                <div className="max-w-[152px] w-full form-group3" key={index}>
                  <ul className="flex items-center w-full gap-[20px]">
                    <li className="flex items-center gap-[12px] mb-3">
                      <input
                        type="radio"
                        id={compareFilterID + index}
                        name={"compare-selector" + compareFilterID + index}
                        checked={item.text == selectedCompareFilter}
                        onChange={() => compareFilterChange(item.text)}
                        className=""
                      />
                      <label
                        htmlFor={compareFilterID + index}
                        className="text-base font-normal leading-[160%] text-customGray"
                      >
                        {item.text}
                      </label>
                      <div className="check"></div>
                    </li>
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* desktop view */}

        {/* mobile view */}
        <div className="block md:hidden md:max-w-[204px] w-full border-b md:border-b-0 md:border-r border-[#EBEFF3] relative pb-2 md:pb-0 mb-2 md:mb-0">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-full text-left bg-gray-100 py-2 px-3 rounded-md flex justify-between items-center"
          >
            <h4 className="text-sm font-bold leading-[160%] text-[#04091E]">Date Filter</h4>
            {isDropdownOpen ? (
            <XMarkIcon className="w-[14px] h-[14px] text-[#EF2121]" />
          ) : (
            <ChevronDownIcon className="w-[14px] h-[14px] text-customGray" />
          )}
            {/* <ChevronDownIcon
              className={`w-5 h-5 transition-transform ${
                isDropdownOpen ? "rotate-180" : ""
              }`}
            /> */}
          </button>
          {isDropdownOpen && (
            <div className="absolute bg-white border border-gray-200 rounded-md mt-2 shadow-lg p-4 z-50 w-full">
              <h6 className="text-base font-bold leading-[160%] text-[#04091E] mb-4">
                Calendar
              </h6>
              <div>
                {calendarFilter.map((item, index) => (
                  <div className="max-w-[152px] w-full form-group3" key={index}>
                    <ul className="flex items-center w-full gap-[20px]">
                      <li className="flex items-center gap-[12px] mb-2">
                        <input
                          type="radio"
                          id={calendarFilterID + index}
                          name={"calendar-selector" + calendarFilterID + index}
                          checked={item.text == selectedCalendarFilter}
                          onChange={() => calendarFilterChange(item.text)}
                        />
                        <label
                          htmlFor={calendarFilterID + index}
                          className="text-base font-normal leading-[160%] text-customGray"
                        >
                          {item.text}
                        </label>
                        <div className="check"></div>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
              <h6 className="text-base font-bold leading-[160%] text-[#04091E] mb-4">
                Compared to
              </h6>
              <div>
                {compareFilter.map((item, index) => (
                  <div className="max-w-[152px] w-full form-group3" key={index}>
                    <ul className="flex items-center w-full gap-[20px]">
                      <li className="flex items-center gap-[12px] mb-2">
                        <input
                          type="radio"
                          id={compareFilterID + index}
                          name={"compare-selector" + compareFilterID + index}
                          checked={item.text == selectedCompareFilter}
                          onChange={() => compareFilterChange(item.text)}
                          className=""
                        />
                        <label
                          htmlFor={compareFilterID + index}
                          className="text-base font-normal leading-[160%] text-customGray"
                        >
                          {item.text}
                        </label>
                        <div className="check"></div>
                      </li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* mobile view */}
        <div className="md:max-w-[340px] w-full md:pl-10">
          <div className="calender-wrapper">
            <Calendar
              className="mb-5"
              onChange={handleCalendarChange}
              selectRange={true}
              maxDate={moment().toDate()}
              value={[
                moment(selectRange?.startDate).toDate(),
                moment(selectRange?.endDate).toDate(),
              ]}
            />
          </div>
          <div className="flex items-center justify-end gap-[30px]">
            <Button
              title="Cancel"
              classes="text-sm font-black leading-[160%] text-[#485868]"
              onClick={handleClose}
            />
            <Button
              title="Apply"
              classes="text-sm font-black leading-[160%] text-white h-[42px] rounded-[10px] bg-primary inline-flex items-center justify-center w-[88px]"
              onClick={handleDateFilter}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAdminCalendar;
